import { useMemo } from "react";
import { useGetThreeSixtyQAListLists360 } from "../../api/threeSixtyLists360";
import { useMyAssignedCheckTypes } from "../../api/ActorAPI";
import { usePermissionValidator } from "../../api/UserPermissionValidators";

import {
  HeaderField,
  WithFilterSortHeader,
  WithFilterSortHeaderBaseProps,
  WithFilterSortHeaderInjectedProps,
} from "../FilterSortHeader";
import { ThreeSixtyQARowRenderer } from "../ThreeSixtyRow";
import { ThreeSixtyListBase } from "../ThreeSixtyListBase";

type ThreeSixtyQABaseProps = {};
const ThreeSixtyQABase = (
  props: ThreeSixtyQABaseProps &
    WithFilterSortHeaderBaseProps &
    WithFilterSortHeaderInjectedProps
) => {
  const perms = usePermissionValidator();

  return (
    <ThreeSixtyListBase
      {...props}
      hasPermission={perms.canView360Qa}
      renderRow={(row, cancel, toggleCancel, forceReload) => (
        <ThreeSixtyQARowRenderer
          key={row.request_uuid}
          row={row}
          cancel={cancel}
          toggleCancel={toggleCancel}
          forceReload={forceReload}
        />
      )}
    />
  );
};

const ThreeSixtyQAWithFilterSortHeader = WithFilterSortHeader(ThreeSixtyQABase);

type ThreeSixtyQAProps = {};
const ThreeSixtyQA = (props: ThreeSixtyQAProps) => {
  const { data: assignedCheckTypes } = useMyAssignedCheckTypes();
  const headerDefs = useMemo<HeaderField[][]>(
    () => [
    [
      {
        display: "Name",
        value_field: "candidate_name",
        filterable: true,
        sortable: true,
      },
      {
        display: "Report ID",
        value_field: "request_uuid",
        filterable: false,
        sortable: true,
      },
    ],
    [
      {
        display: "Company",
        value_field: "company_name",
        filterable: true,
        sortable: true,
      },
    ],
    [
      {
        display: "Check Type",
        key_field: "check_type_uuid",
        value_field: "check_type_name",
        filterable: true,
        sortable: true,
        preFilter: assignedCheckTypes?.has_task
          ? assignedCheckTypes.check_type_uuids
          : undefined,
      },
      {
        display: "Behavior Kit",
        value_field: "behavior_kit_name",
        filterable: false,
        sortable: true,
      },
    ],
    [
      {
        display: "Date Added",
        value_field: "requested_at",
        filterable: true,
        sortable: true,
      },
    ],
    [
      {
        display: "Due Date",
        value_field: "due_date",
        filterable: true,
        sortable: true,
      },
    ],
    [
      {
        display: "Assigned To",
        value_field: "locked_by",
        filterable: true,
        sortable: true,
      },
    ],
    [
      {
        display: "Client Ref #",
        value_field: "custom_id",
        filterable: true,
        sortable: true,
      },
    ],
  ],
  [assignedCheckTypes]
  );
  return (
    <ThreeSixtyQAWithFilterSortHeader
      page_size={20}
      date_fields={["requested_at", "due_date"]}
      default_sort_field="due_date"
      default_sort_reverse
      loader={useGetThreeSixtyQAListLists360()}
      header_definitions={headerDefs}
    />
  );
};

export default ThreeSixtyQA;
